module.exports = __webpack_public_path__ + "static/media/trip-advisor-icon.87458933.svg";